import { TemplateResult, nothing } from 'lit';
export * from './property-change-manager';

export type HtmlTemplate = TemplateResult | typeof nothing | symbol | string | undefined;
